import React from 'react'
import { framework_tool, component_tool } from '@/tool'
const { WizComponent, WizCard, WizRow, WizCol, WizForm, WizButton } = component_tool
const { WizFileUpload } = framework_tool
import { WizBraftEditorPlus } from '@/containers/common'

const validator = (title, rule, value, callback) => {
    if (value && value !== '<p></p>') {
        callback()
        return
    }
    callback('请输入' + title)
}

class PreAuditResult extends WizComponent {

    componentName = 'PreAuditResult'

    constructor(props) {
        super(props)
        this.state = {}
    }

    _onSub = () => {
        this.refs.form.validateFields((err, values) => {
            if (!err) {
                let { onSub } = this.props
                let { content, file } = values
                let fileId = file && file.length ? file[0].fileId : null
                onSub && onSub({ content, fileId })
            }
        })
    }

    _renderFooter = () => {
        return (
            <WizRow className='form-btns row-item'>
                <WizCol span={24}>
                    <WizButton type='primary' onClick={() => this._onSub()}>{'确认下发'}</WizButton>
                </WizCol>
            </WizRow>
        )
    }

    render() {
        let { title, type, content, data, mode } = this.props
        switch (type) {
            case 'send':
                let columns = [{
                    title: title,
                    name: 'content',
                    dataIndex: 'content',
                    formItem: {
                        type: 'custom',
                        render: (r, f) => {
                            const { getFieldDecorator } = f
                            return getFieldDecorator('content', {
                                rules: [{ required: true, validator: (rule, value, callback) => validator(title, rule, value, callback) }]
                            })(<WizBraftEditorPlus links={[0, 1, 2, 3]} />)
                        }
                    },
                }]
                if (mode === 'review') {
                    columns = columns.concat([{
                        title: '整改计划',
                        name: 'file',
                        dataIndex: 'file',
                        formItem: {
                            type: 'custom',
                            render: (r, f) => {
                                const { getFieldDecorator } = f
                                let initialValue = []
                                if (r && r.fileId && r.fileId != -1) {
                                    initialValue = [{ fileId: r.fileId }]
                                }
                                return getFieldDecorator('file', {
                                    initialValue,
                                    rules: [{ required: true, message: '请上传整改计划' }]
                                })(
                                    <WizFileUpload
                                        accept={'.zip, .rar, .xls, .xlsx, .doc, .docx, .pdf'}
                                        listType={'text'}
                                        limit={-1}
                                        progress={{
                                            strokeColor: { '0%': '#108ee9', '100%': '#87d068' },
                                            strokeWidth: 3,
                                            format: percent => `${parseFloat(percent.toFixed(2))}%`,
                                        }}
                                        beforeUpload={(file) => {
                                            const isLt4G = file.size <= 4 * 1024 * 1024 * 1024
                                            if (!isLt4G) {
                                                message.error('整改计划不得超过4GB!')
                                            }
                                            return isLt4G
                                        }}
                                    />
                                )
                            }
                        },
                    }])
                }
                let formProps = {
                    ref: 'form',
                    columns,
                    record: null,
                    preview: null,
                    footer: this._renderFooter(),
                    formItemLayout: {
                        labelCol: { span: 4 },
                        wrapperCol: { span: 17 }
                    },
                    style: { maxWidth: '100%', width: '100%' }
                }
                return (
                    <WizCard title={title}>
                        <WizForm key={'send'} {...formProps} />
                    </WizCard>
                )
            case 'look':
                if (content) {
                    let columns = [{
                        title: '整改计划',
                        name: 'fileId',
                        dataIndex: 'fileId',
                        formItem: {
                            type: 'custom',
                            render: (r, f) => {
                                let url = r && r.fileId ? getOssFilePath(r.fileId) : ''
                                let fileName = r && r.fileName ? r.fileName : ''
                                return <a href={url} style={{ color: '#1890ff' }}>{fileName}</a>
                            }
                        }
                    }]
                    let formProps = {
                        ref: 'form',
                        columns,
                        record: data,
                        preview: null,
                        footer: false,
                        formItemLayout: {
                            labelCol: { span: 4 },
                            wrapperCol: { span: 17 }
                        },
                        style: { maxWidth: '100%', width: '100%' }
                    }
                    return (
                        <WizCard title={title}>
                            <div style={{ textAlign: 'center', color: 'red', fontSize: 24, margin: 16 }}>{title}</div>
                            <WizRow className='pre-audit-result-look'>
                                <WizCol offset={3} span={18}>
                                    <div dangerouslySetInnerHTML={{ __html: content }} ></div>
                                </WizCol>
                            </WizRow>
                            {mode === 'review' ? <WizForm {...formProps} /> : null}
                        </WizCard>
                    )
                }
        }
        return null
    }
}

export default PreAuditResult


